const BASE_URL = process.env.REACT_APP_BACKEND_URL
const PROFILE_BASE = `${BASE_URL}/api/v2/admin/curators`

const parseResponse = async (res: Response) => {
  const json = await res.json()
  const statusCode = json?.status_code ?? res.status
  if (!res.ok || statusCode !== 200) {
    const message =
      json?.error?.message || json?.message || `Request failed (${res.status})`
    throw new Error(message)
  }
  return json?.data ?? json
}

export const fetchCuratorProfile = async () => {
  const res = await fetch(`${PROFILE_BASE}/me/get`, {
    credentials: 'include',
    headers: [['Cache-Control', 'no-cache']],
  })
  return parseResponse(res)
}

export const updateCuratorProfile = async (
  id: number | string,
  payload: any,
) => {
  const res = await fetch(`${PROFILE_BASE}/${id}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
  return parseResponse(res)
}

export const createCurator = async (payload: any) => {
  const res = await fetch(`${PROFILE_BASE}/`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
  return parseResponse(res)
}
